module.exports = __webpack_public_path__ + "img/gehujiaqing.cc7dd610.png";